import { BlankState } from '@domain-group/suit-theme'

import BlankStateImage from './assets/no-campaigns.svg'

const CampaignsBlankState = () => (
  <BlankState boxProps={{ marginBottom: 'large' }} imageUrl={BlankStateImage}>
    {/*
     // @ts-expect-error TS2339 */}
    <BlankState.Title>No Campaigns</BlankState.Title>

    {/*
     // @ts-expect-error TS2339 */}
    <BlankState.Paragraph>
      No campaigns to display. Campaigns will automatically feed from your CRM if set,
      otherwise you can add a property in the dashboard. If you&apos;ve filtered the
      results you may need to remove some filters to see more.
      {/*
     // @ts-expect-error TS2339 */}
    </BlankState.Paragraph>
  </BlankState>
)

export default CampaignsBlankState
